import Invoices from "../views/Invoices/Invoices";
import GlobalInvoices from "../views/GlobalInvoices/GlobalInvoices";
import GlobalInvoiceStatusView from "../views/GlobalInvoiceStatus/GlobalInvoiceStatusView";
import InvoicesTransfer_L from "../views/InvoicesTransfer/lazy";
import CreditNotes_L from "views/CreditNotes/lazy";
import { NotesMigration } from "views/NotesMigration/NotesMigration";
import { NotesFiscalUpdate } from "views/NotesFiscalUpdate/NotesFiscalUpdate";

import Receipt from "@material-ui/icons/Receipt";
import { PERMISSIONS } from "router/permissions";
import { CashInvoices } from "views/CashInvoices/CashInvoices";
import { cashInvoicesType } from "redux/reducers/invoices/cashInvoicesType";
import { PolicyManagmentView } from "views/policyManagment/PolicyManagmentView";
import { policyManagmentTypes } from "redux/reducers/policyManagment/types";
import { globalInvoiceTypes } from "redux/reducers/globalInvoices/types";
import { invoicesTypes } from "redux/reducers/invoices/types";

const {
  INVOICES,
  INVOICES_ERP,
  INVOICES_TRANSFER,
  INVOICES_GLOBAL,
  INVOICE_GLOBAL_VIEW,
  INVOICES_CASH,
  INVOICES_ERP_UPDATE_SAT,
  INVOICES_ERP_MIGRATION,
  POLICY_VIEW,
} = PERMISSIONS;

const invoiceCashConfig = {
  reducer: "cashInvoices",
  restoreKey: cashInvoicesType.RESTORE_INITIAL,
};
const policyConfig = {
  reducer: "policy",
  restoreKey: policyManagmentTypes.RESTORE_INITIAL,
};

const globalInvoicesConfig = {
  reducer: "globalInvoices",
  restoreKey: globalInvoiceTypes.RESTORE_INITIAL,
};

const invoicesConfig = {
  reducer: "invoices",
  restoreKey: invoicesTypes.RESTORE_INITIAL,
};

export const invoicesRoutes = [
  {
    collapse: true,
    name: "Facturas",
    icon: Receipt,
    state: "invoicesCollapse",
    inSidebar: true,
    isProtected: true,
    rule: INVOICES,
    views: [
      {
        path: "/facturas",
        name: "Listado de Facturas",
        mini: "LT",
        component: Invoices,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVOICES,
        ...invoicesConfig,
      },
      {
        path: "/facturas-traslado",
        name: "Facturas de Traslado",
        mini: "FT",
        component: InvoicesTransfer_L,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVOICES_TRANSFER,
      },
      {
        path: "/facturas-globales",
        name: "Facturas Globales",
        mini: "FG",
        component: GlobalInvoices,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVOICES_GLOBAL,
        ...globalInvoicesConfig,
      },
      {
        path: "/facturas-globales-estatus",
        name: "Facturas Globales Estatus",
        mini: "FGE",
        component: GlobalInvoiceStatusView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVOICE_GLOBAL_VIEW,
      },
      {
        path: "/facturas-credito",
        name: "Facturación de Crédito",
        mini: "NT",
        component: CreditNotes_L,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVOICES_ERP,
      },
      {
        path: "/notas_actualizacion_fiscal",
        name: "Notas Actualización Fiscal",
        mini: "NA",
        component: NotesFiscalUpdate,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVOICES_ERP_UPDATE_SAT,
      },
      {
        path: "/notas_migrar",
        name: "Notas a Migrar",
        mini: "NM",
        component: NotesMigration,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVOICES_ERP_MIGRATION,
      },
      {
        path: "/facturas_contado",
        name: "Facturación de Contado",
        mini: "FC",
        component: CashInvoices,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVOICES_CASH,
        ...invoiceCashConfig,
      },

      {
        path: "/polizas",
        name: "Polizas",
        mini: "PL",
        component: PolicyManagmentView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: POLICY_VIEW,
        ...policyConfig,
      },
    ],
  },
];
